import React, { Component } from "react";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar,Asidebar,Dashboard } from './Components/Components';
import './pages/Dashboard/dashboard.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Page404 from "./Components/404";
import { DashboardRoutes } from "./routes/DashboardRoutes";

class App extends Component{
  constructor(props){
    super(props)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.state = {
      viewMobile: false,
      openMenu: true,
      viewTab: 0,
      data:{
        0: "",
        1: "",
        2: ""
      },
      dataGrafica: [
      ],
      year: new Date().getFullYear(),
      loadingData: true,
      point: {},
      oficinas:[],
      dataOficinas: {},
      profileOficinas:[],
      profileOficinasAgentes:[],
      viewOficinaData:{
        agentes: "1",
        tipo_agente: "0",
      },
      exportFileProdTableAgentes: false,
      exportFileCobTableAgentes: false,

      exportFileRenovacionesAgente: false,
      exportFileProdCobDetalleAgente: false,
      exportFileProdCobAgentesByIdGrupo: false,
      exportFileProdCobAgentesByIdPromotoria: false,
      exportFileCierrePorCuatrimestre: false,
    }
  }

  componentDidMount(){
    // const { viewTab } = this.state;
    // this.getInitDashboard(viewTab);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const { openMenu,width,viewMobile } = this.state;
    this.setState({ 
      width: window.innerWidth, 
      height: window.innerHeight 
    },
      this.checkDimensions
    );
  }

  checkDimensions(){
    const { openMenu,width,viewMobile } = this.state;
    if(width <= 991 && viewMobile==false){
      this.setState({
        openMenu: false,
        viewMobile : true
      })
    }
    if(width >= 992 && viewMobile==true){
      this.setState({
        openMenu: true,
        viewMobile : false
      })
    }
  }

  updateState(obj){
    this.setState(obj)
  }

  verifyDataDashboard(opt){
    const {data} = this.state;
    if(data[opt]===""){
      this.setState({loadingData:true})
      return true
    }else{
      this.setState({loadingData:false})
      return false
    }
  }

  loadData(opt,oficinas,agentes,tipo_agente,id_login){
    // console.log('load_data',id_login)
    // if(this.verifyDataDashboard(opt)){
      this.setState({loadingData:true})
      return this.getInitDashboard(opt,oficinas,agentes,tipo_agente,id_login);
    // }
  }

  getInitDashboard(opt='0',oficinas=[],agentes='0',tipo_agente='0',id_login=''){

    const {data} = this.state;
    const newOficinas = [];
    if(oficinas){
      oficinas.map(element => {
        newOficinas.push(element.value);
      });
    }

    const values = {
      'id_login' : id_login,
      'opt' : opt,
      'oficinas': newOficinas,
      'agentes' : agentes,
      'tipo_agente' : tipo_agente,
    }
    
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInitDashboard`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(values),
    })
    .then(res => res.json())
    .then((res) => {
      data[opt] = res;
      this.setState({
        data,
        loadingData: false,
        oficinas: res.oficinas
      })
    })
  }

  render(){
    const {openMenu,viewMobile} = this.state;

    return (
      <Router>
        <Switch>
          <Route path="/">
            <DashboardRoutes state={this.state} updateState={this.updateState.bind(this)} loadData={this.loadData.bind(this)} />
          </Route>
        </Switch>
        
        <div className={`ws_overlay ${(openMenu && viewMobile) ? 'open_aside' : ''}`} onClick={ () => { this.setState({ openMenu : !openMenu })} }></div>
      </Router>
    )

    return(
      <Router>
        <Switch>

          <Route exact path="/">
            <Navbar state={this.state} updateState={this.updateState.bind(this)} />
            <Asidebar state={this.state} updateState={this.updateState.bind(this)} />
            <Dashboard state={this.state} updateState={this.updateState.bind(this)} loadData={this.loadData.bind(this)}/>
            <div className={`ws_overlay ${(openMenu && viewMobile) ? 'open_aside' : ''}`} onClick={ () => { this.setState({ openMenu : !openMenu })} }></div>
          </Route>

          <Route path="*">
            <Navbar state={this.state} updateState={this.updateState.bind(this)} />
            <Asidebar state={this.state} updateState={this.updateState.bind(this)} />
            <Page404 state={this.state} updateState={this.updateState.bind(this)}/>
            <div className={`ws_overlay ${(openMenu && viewMobile) ? 'open_aside' : ''}`} onClick={ () => { this.setState({ openMenu : !openMenu })} }></div>
          </Route>

        </Switch>
      </Router>
    )
  }
  

}

export default App;
